import React from 'react';
import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetFunds(type, order, page, fundAssetClasses, series, name,
  companySlug) {
  const common = (t, o, p, ac, s, n, cl) => ({
    params: {
      type: t, order: o, page: p, fund_asset_classes: ac, series: s, name: n, company_slug: cl,
    },
  });

  const [state, q] = useAxios({
    url: '/api/v1/funds',
    method: 'GET',
    ...common(type, order, page, fundAssetClasses, series, name, companySlug),
  }, { manual: true });

  const executeQuery = React.useCallback((t, o, p, ac, s, n, cl) => q(
    common(t, o, p, ac, s, n, cl),
  ), [q]);

  return [state, executeQuery];
}
